let sysconfig:any;

export function initSysConfig(db){
    sysconfig = db.table('sysconfig');
}

export function addSysConfig(key:string,value:any){
    sysconfig.add({key,value})
}
export function updateSysConfig(key:string,value:any){
    sysconfig.put({key,value});
}
export function getSysConfig(key:string){
    return sysconfig.get(key);
}